import { render } from "./ProjectFileContentFaults.vue?vue&type=template&id=6d346d32&scoped=true"
import script from "./ProjectFileContentFaults.vue?vue&type=script&lang=js"
export * from "./ProjectFileContentFaults.vue?vue&type=script&lang=js"

import "./ProjectFileContentFaults.vue?vue&type=style&index=0&id=6d346d32&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d346d32"]])

export default __exports__